import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackReplacementsUploadedSpec,
  trackSnippetCreatedSpec,
  trackSnippetDeletedSpec,
  trackSnippetUpdatedSpec,
  trackSnippetUploadedSpec,
  trackSnippetsUploadedSpec,
  type ReplacementsUploaded,
  type SnippetCreated,
  type SnippetDeleted,
  type SnippetUpdated,
  type SnippetUploaded,
  type SnippetsUploaded,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const snippetEvents: SnowplowEventMap = {
  [TrackingEventName.SnippetCreated]: (props) =>
    trackSnippetCreatedSpec(props as SnippetCreated),
  [TrackingEventName.SnippetUpdated]: (props) =>
    trackSnippetUpdatedSpec(props as SnippetUpdated),
  [TrackingEventName.SnippetDeleted]: (props) =>
    trackSnippetDeletedSpec(props as SnippetDeleted),
  [TrackingEventName.SnippetUploaded]: (props) =>
    trackSnippetUploadedSpec(props as SnippetUploaded),
  [TrackingEventName.SnippetsUploaded]: (props) =>
    trackSnippetsUploadedSpec(props as SnippetsUploaded),
  [TrackingEventName.ReplacementsUploaded]: (props) =>
    trackReplacementsUploadedSpec(props as ReplacementsUploaded),
};
